
const Spinner = ({ size = "h-12 w-12", className = "" }) => {
  return (
    <div className={`flex items-center justify-center h-full ${className}`}>
      <div
        className={`animate-spin rounded-full ${size} border-4 border-lz-paper-border border-t-lz-candle-dim`}
      />
    </div>
  );
};

export default Spinner;
